export function removeDuplicates<T>(array: T[]): T[] {
  return [...new Set(array)];
}

export function removeFalsyValues<T>(input: (T | undefined | null)[]): T[] {
  return input.filter((element): element is T => {
    return !!element;
  });
}
